// src/components/Besoin.jsx
import React from "react";

export default function Besoin() {
  return (
    <section className="chapter">
      <header className="chapter__header">
        <h2 className="chapter__title">Publier un besoin</h2>
        <p className="chapter__subtitle">
          Le but de cette plateforme est de vous fournir des partenaires de qualité afin que vous puissiez rester concentré sur votre activité. Elle vous aide à identifier un adhérent capable de répondre à votre besoin.
        </p>
      </header>

      <div className="chapter__content">
        <p className="chapter__intro">
          Plus la plateforme recevra de besoins, plus les contributeurs pourront donner leur avis, ce qui permettra d'améliorer la qualité des services. Pourquoi ? Parce que le moteur d'attribution tiendra compte de vos retours dans son algorithme de sélection.
        </p>
        <p className="chapter__intro">
          Cela signifie que les prestataires qui ne parviennent pas à satisfaire pleinement leurs clients seront progressivement écartés de la plateforme et ne pourront probablement plus contribuer à l’avenir.
        </p>
        <p className="chapter__intro">
          Vos retours sont essentiels pour améliorer continuellement la qualité des services proposés. Le moteur d'attribution s'appuie sur vos avis pour affiner ses recommandations.
        </p>

        <div className="chapter__block">
          <h3 className="chapter__block-title">Présenter son besoin</h3>
          <p className="chapter__block-text">
            En tant qu’adhérent de la plateforme, vous pouvez publier un besoin en le décrivant le plus précisément possible.
          </p>
          <p className="chapter__block-text">
            Vous pouvez également indiquer le nom et les coordonnées (email, téléphone) de la personne à contacter.
          </p>
          <p className="chapter__block-text">
            En publiant une opportunité, vous acceptez que les coordonnées saisies soient transmises aux adhérents sélectionnés par la plateforme.
          </p>
        </div>

        <div className="chapter__block">
          <h3 className="chapter__block-title">Notez le prestataire</h3>
          <p className="chapter__block-text">
            La plateforme vous proposera des adhérents sans pouvoir garantir la qualité de leur service. Il est donc essentiel de qualifier ceux qui sont intervenus. Il est également important de donner une première chance aux nouveaux arrivants. Comme vous, ils ont lu ces pages et souhaitent probablement rester actifs le plus longtemps possible. Ils ont donc tout intérêt à fournir un service de qualité.
            <br />
            S’ils demandent à être retirés de la plateforme, ils ne recevront de toute façon plus d’opportunités.
          </p>
        </div>
      </div>
    </section>
  );
}
